import { render, staticRenderFns } from "./NcrAreaOwnerCpar.vue?vue&type=template&id=2cd046ff&"
import script from "./NcrAreaOwnerCpar.vue?vue&type=script&lang=js&"
export * from "./NcrAreaOwnerCpar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports